import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_ORDER_DETAIL_LIST_REQUEST,
  GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_REQUEST,
  SET_ORDER_STATUS_REQUEST,
} from "./actionTypes";
import {
  getOrderDetailListResponse,
  getOrderDetailWithLinesByOrderIdResponse,
  setOrderStatusResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getOrderDetailList({ payload: { filter } }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/Order/GetOrderDetailsByParams",
      filter
    );
    yield put(getOrderDetailListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getOrderDetailWithLinesByOrderId({ payload: { orderId }, callback }) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/Order/GetOrderDetailWithLinesByOrderDetailId/" + orderId
    );
    yield put(getOrderDetailWithLinesByOrderIdResponse(response));
    callback && callback(response);
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* setOrderStatus({ payload: { orderId, status } }) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      `/Order/SetOrderStatus/${orderId}/${status}`
    );
    yield put(setOrderStatusResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchOrderDetail() {
  yield takeEvery(GET_ORDER_DETAIL_LIST_REQUEST, getOrderDetailList);
  yield takeEvery(
    GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_REQUEST,
    getOrderDetailWithLinesByOrderId
  );
  yield takeEvery(SET_ORDER_STATUS_REQUEST, setOrderStatus);
}

function* orderDetailSaga() {
  yield all([fork(watchOrderDetail)]);
}

export default orderDetailSaga;
